import axios from 'axios'

import { auth } from '../../core/firebase/config'
import { getAuthToken } from '../../core/utils/auth-token'

export const createDriverClient = (
  baseURL: string,
  credential: (uid: string) => Promise<string>
) => ({
  async request(uid: string, path: string, body: unknown, signal: AbortSignal) {
    try {
      if (!uid || signal.aborted) throw new Error('unavailable')
      const token = await credential(uid)
      if (signal.aborted) throw new Error('unavailable')
      const response = await axios.request({
        baseURL: `${baseURL.replace(/\/+$/, '')}/v1/driver-agreements`,
        data: body,
        headers: { Authorization: `Bearer ${token}` },
        method: body === undefined ? 'GET' : 'POST',
        signal,
        timeout: 30000,
        url: path,
      })
      return response.data
    } catch (error) {
      // Do not expose Axios config, credentials or private response URLs to logging.
      throw Object.assign(new Error('Driver agreement request unavailable'), {
        response: {
          data: {
            customError: axios.isAxiosError(error)
              ? error.response?.data?.customError
              : undefined,
          },
          status: axios.isAxiosError(error)
            ? error.response?.status
            : undefined,
        },
      })
    }
  },
})

export const driverClient = createDriverClient(
  import.meta.env.VITE_DRIVER_API_BASE_URL,
  async (uid) => {
    if (auth.currentUser?.uid !== uid) throw new Error('unavailable')
    const token = await getAuthToken()
    if (auth.currentUser?.uid !== uid) throw new Error('unavailable')
    return token
  }
)
